<template>
    <transition name="fade-down">
        <ul v-if="error" class="error-list">
            <template v-if="error.length">
                <li v-for="er in error" :key="er.detail" :style="textStyle">
                    {{ er.detail ? er.detail.trim() : er[0].trim() }}
                </li>
            </template>
            <li v-else :style="textStyle">
                {{ typeof error.detail === 'string' ? error.detail.trim() : 'Error occured' }}
            </li>
        </ul>
    </transition>
</template>

<script>
export default {
    name: 'ErrorList',
    props: {
        error: {
            type: [Array, Object],
            default: undefined,
        },
        textStyle: {
            type: [String, Object],
            default: undefined,
        },
    },
};
</script>

<style lang="scss">
.error-list {
    margin: 15px 0;
    padding: 0;
    list-style-type: none;

    li {
        color: red;
    }
}
</style>
